import {
	useContext
} from "react";
import {
	renderDate
} from "~/utils";
import {
	Pagination,
	Table
} from "antd";
import {
	AppContext
} from "~/context/AppProvider";
import {
	LIST_USER_STATUS,
} from "~/app/constants";
import {StatusLabel} from "~/components";
import {UserTableAction} from "../index";
import {Link} from "react-router-dom";

function UserTable({items = [], pagination, setItemEdit, handleEvent, can, selectedRowKeys, setSelectedRowKeys}) {

	const {tableHeight} = useContext(AppContext);

	let columns = [
		{ title: 'Username', dataIndex: 'username', key: "username", width: '200px', render: (_, item) => (
			<>
				<p className="font-bold color-theme">{item?.username}</p>
			</>
		)},
		{ title: 'Họ & Tên', dataIndex: 'name', key: "name", width: '200px', render: (_, item) => (
				<>
					<p className="font-bold">{item?.firstname + ' ' + item?.lastname}</p>
				</>
			)},
		{ title: 'Email', dataIndex: 'email', key: "email", width: '100px'},
		{ title: 'Số điện thoại', dataIndex: 'phone', key: "phone", width: '100px'},
		{
			title: 'Chức vụ', dataIndex: 'role', key: "role", width: '120px', render: (_, item) => (
			<>
				<p className="font-bold">{item?.roleName}</p>
			</>
		)},
		{ title: 'Trạng thái', dataIndex: 'status', key: "status", width: '100px', render: (_, item) => (
			<>
				<StatusLabel small type={item?.status.badge} border>{item?.status.label}</StatusLabel>
			</>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '220px', render: (_, item) => (
			<UserTableAction item={item} setItemEdit={setItemEdit} handleEvent={handleEvent} can={can} />
		)},
	];

	const dataSource= items.map(row => ({
		...row,
		key: row.id, // I added this line
	}));

	return (
		<div className="table-wrapper">
			<div className="order-table table-box">
				<Table
					columns={columns}
					dataSource={dataSource}
					scroll={{ y:tableHeight, x: 'max-content' }}
					pagination={false}
				/>
			</div>
			<div className="d-flex justify-content-end">
				<Pagination
					current={pagination.page}
					defaultCurrent={1}
					defaultPageSize={20}
					pageSize={pagination.limit}
					total={pagination.totalRows}
					onChange={handleEvent.changePagination}
					showSizeChanger={false}
				/>
			</div>

		</div>
	)
}

export default UserTable;